function setDispatchReports(data) {
	return {
		type: 'SET_DISPATCH_REPORTS',
		payload: data,
	};
}

export { setDispatchReports };
